
import Vue from 'vue';

export default Vue.extend({
	name: 'PageHeader',

	props: {
		title: {
			type: String,
			required: true
		},

		fontSize: {
			type: String,
			default: '1.8rem'
		},

		textAlign: {
			type: String,
			default: 'text-center'
		},

		subtitle: {
			type: String,
			default: undefined
		},

		titleClass: {
			type: String,
			default: 'mt-4'
		},

		noMargin: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		}
	}
});
